import React from "react";
import "./Hero.css";
import { FaLandmark } from "react-icons/fa";
import heroImage from "../../images/yara_hero.jpeg";

const Hero = () => {
  return (
    <section className="hero" id="hero" aria-label="Apresentação do escritório">
      <div className="hero-content">
        <div className="hero-text">
          <div className="hero-title-box">
            <FaLandmark className="hero-icon" aria-hidden="true" />
            <h1>Advocacia Criminal</h1>
          </div>

          <p className="descricao">
            Yara Catarina Carreira — advogada criminalista. Atuação preventiva e contenciosa,
            com acompanhamento estratégico em todo o Brasil, incluindo audiência de custódia,
            habeas corpus e recursos criminais.
          </p>
        </div>

        <div className="hero-image">
          <img
            src={heroImage}
            alt="Yara Catarina Carreira, advogada criminalista"
            loading="eager"
            decoding="async"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
